

function HashMap() {
    /** Map 大小 **/
    var size = 0;
    /** 对象 **/
    var entry = new Object();

    /** 存 **/
    this.put = function (key, value) {
        if (!this.containsKey(key)) {
            size++;
        }
        entry[key] = value;
    }

    /** 取 **/
    this.get = function (key) {
        if (this.containsKey(key)) {
            return entry[key];
        } else {
            return null;
        }
    }

    /** 删除 **/
    this.remove = function (key) {
        if (delete entry[key]) {
            size--;
        }
    }

    /** 是否包含 Key **/
    this.containsKey = function (key) {
        return (key in entry);
    }

    /** 是否包含 Value **/
    this.containsValue = function (value) {
        for (var prop in entry) {
            if (entry[prop] == value) {
                return true;
            }
        }
        return false;
    }

    /** 所有 Value **/
    this.values = function () {
        var values = new Array(size);
        for (var prop in entry) {
            values.push(entry[prop]);
        }
        return values;
    }

    /** 所有 Key **/
    this.keys = function () {
        var keys = new Array(size);
        for (var prop in entry) {
            keys.push(prop);
        }
        return keys;
    }

    /** Map Size **/
    this.size = function () {
        return size;
    }
}

var RE = {
    currentRange: {
        startContainer: null,
        startOffset: 0,
        endContainer: null,
        endOffset: 0
    },
    cache: {
        editor: null,
        title: null,
        currentLink: null,
        line: null
    },
    /**
     * 当前需要的按钮在这里设置
     * 文字对齐方式
     *@param justifyCenter 对光标插入位置或者所选内容进行文字居中。
     *@param justifyFull 对光标插入位置或者所选内容进行文本对齐。
     *@param justifyLeft 对光标插入位置或者所选内容进行左对齐。
     *@param justifyRight 对光标插入位置或者所选内容进行右对齐。
     *@param bold 加粗 
     *@param italic 斜体
     *@param indent 引用
     *@param outdent 取消引用
     *@param redo 重做
     *@param undo 撤销
     *@param superscript 上角标
     *@param subscript 下角标
     *@param fontSize 字号
     *@param foreColor 字体颜色
     *@param underline 下划线
     *@param strikeThrough 删除线
     *@param insertOrderedList 插入有序列表
     *@param insertUnorderedList 插入无序列表
     *@param removeFormat 清除格式
     */
    commandSet: ['removeFormat', 'subscript', 'superscript', 'outdent', 'indent', 'foreColor', 'insertUnorderedList', 'insertOrderedList', 'fontSize', 'strikeThrough', 'underline', 'bold', 'justifyFull', 'justifyLeft', 'justifyCenter', 'justifyRight', 'italic', 'redo', 'undo'],
    commandArray: {
        bold: false,
        fontSize: "4",
        foreColor: "rgb(0, 0, 0)",
        indent: false,
        italic: false,
        justifyCenter: false,
        justifyFull: false,
        justifyLeft: true,
        justifyRight: false,
        justify: 'justifyLeft',
        list: "",
        outdent: false,
        redo: false,
        removeFormat: false,
        search: "⁮",
        strikeThrough: false,
        subscript: false,
        superscript: false,
        title: "div",
        underline: false,
        undo: false,
        outline: '',
        getcontent:''
        
    },

    /**
     * 初始化的配置信息 不用管
     */
    schemeCache: {
        FOCUS_SCHEME: 'focus://',
        CHANGE_SCHEME: 'change://',
        STATE_SCHEME: 'state://',
        CALLBACK_SCHEME: 'callback://',
        IMAGE_SCHEME: 'image://'
    },
    setting: {
        screenWidth: 0,
        margin: 20
    },
    imageCache: new HashMap(),
    init: function init() {
        //初始化内部变量
        var _self = this;
         _self.initCache();
        _self.initSetting();
        _self.bind();
        _self.focus();
    },
    // 标题字数监听
    inputlength: function inputlength(value) { 
        document.getElementById("idlength").innerText = value.length
        if (value.length >= 50 && value.length <= 4) {
            document.getElementById("idlengthbox").style.color = "red"
            document.getElementById("idlengthbox").style.textAlign = "right"
        } else {
            document.getElementById("idlengthbox").style.color = "#999"
            document.getElementById("idlengthbox").style.textAlign = "right"
        }
    },

    /**
     * 事件绑定  
     * 包括失去焦点  获得焦点
     */
    bind: function bind() {
        var _self = this; 
        var _self$schemeCache = _self.schemeCache,
            FOCUS_SCHEME = _self$schemeCache.FOCUS_SCHEME,
            STATE_SCHEME = _self$schemeCache.STATE_SCHEME,
            CALLBACK_SCHEME = _self$schemeCache.CALLBACK_SCHEME;


        document.addEventListener('selectionchange', _self.saveRange, false);

        _self.cache.title.addEventListener('focus', function () {
            // window.AndroidInterface.setViewEnabled(true);
        }, false);

        // 获取焦点
        _self.cache.editor.addEventListener('focus', function (evt) {
            // 输入时获取html的内容，length = 0添加p标签

            if (_self.cache.editor.innerHTML.length == 0) {
                _self.cache.editor.innerHTML = '<div divContent="divContent">&#8302</div>'
            }
            //_self.getEditItem(evt);
        }, false);

        _self.cache.title.addEventListener('blur', function () {
            // window.AndroidInterface.setViewEnabled(false);
        }, false);

        // 失去焦点时
        _self.cache.editor.addEventListener('blur', function () {
            _self.saveRange();
            // 如果只有"<p>&#8302</p>"则作为无文本处理
            if (_self.cache.editor.innerHTML == '<div divContent="divContent">&#8302</div>') {
                _self.cache.editor.innerHTML = ""
            }
        }, false);

        _self.cache.editor.addEventListener('click', function (evt) {
            _self.saveRange();
            _self.getEditItem(evt);
        }, false);
 
        _self.cache.editor.addEventListener('keydown', function (evt) {
            // 输入时获取html的内容，length = 0添加p标签
             _self.saveRange(); 
            if (_self.cache.editor.innerHTML.length == 0) {
               
                document.execCommand('insertHtml', false, '<div divContent="divContent">&#8302</div>');
            } 
          if(evt.keyCode==32){
             
        }
            if (evt.keyCode == 13) {
                //回车执行查询
               let div=document.createElement(div)
               div.setAttribute('divcontent', "divContent") 
               document.execCommand('insertBrOnReturn',false)
            }
            _self.getEditItem(evt);
            if (evt.which == 37 || evt.which == 39 || evt.which == 13 || evt.which == 8) {
              //console.log(document.getSelection())
            } 
        }, false);
        _self.cache.editor.addEventListener('input', function () {
            // AndroidInterface.staticWords(_self.staticWords());
        }, false);

    },



    /**
     * 设置当前浏览器的最小高度
     */
    initCache: function initCache() {
        var _self = this;
        _self.cache.editor = document.getElementById('editor'); 
        _self.cache.title = document.getElementById('title');
        _self.cache.line = document.getElementsByClassName('line')[0];
        //_self.cache.editor.style.height = window.innerHeight - 69 - document.getElementById('footer').clientHeight - 44 - 20 + 'px';
    },
    /**
     * 监听当前浏览器的宽度
     */
    initSetting: function initSetting() {
        var _self = this;
        _self.setting.screenWidth = window.innerWidth - 20;
    },

    /**
     * 获得焦点事件
     */
    focus: function focus() {
        //聚焦
      
        var _self = this;
        var range = document.createRange(); 
        range.selectNodeContents(this.cache.editor); 
        range.collapse(false);
        var select = window.getSelection();
        select.removeAllRanges();
        select.addRange(range); 
        _self.cache.editor.focus();
    },


    staticWords: function staticWords() {
        var _self = this;
        var content = _self.cache.editor.innerHTML.replace(/<div\sclass="tips">.*<\/div>|<\/?[^>]*>/g, '').replace(/\s+/, '').trim();
        return content.length;
    },


    /**
     * 保存节点
     * 
     * */
    saveRange: function saveRange() {
        //保存节点位置
        var _self = this;
        var selection = window.getSelection();  
        if (selection.rangeCount > 0) {
            var range = selection.getRangeAt(0);
            var startContainer = range.startContainer,
                startOffset = range.startOffset,
                endContainer = range.endContainer,
                endOffset = range.endOffset;
            _self.currentRange = {
                startContainer: startContainer,
                startOffset: startOffset,
                endContainer: endContainer,
                endOffset: endOffset
            };
        }
    },
    /**
     * 还原节点
     * 
    */
    reduceRange: function reduceRange() {
        //还原节点位置
        var _self = this;
        var _self$currentRange = _self.currentRange,
            startContainer = _self$currentRange.startContainer,
            startOffset = _self$currentRange.startOffset,
            endContainer = _self$currentRange.endContainer,
            endOffset = _self$currentRange.endOffset; 
        var range = document.createRange();
        var selection = window.getSelection();
        selection.removeAllRanges();
        range.setStart(startContainer, startOffset);
        range.setEnd(endContainer, endOffset);
        selection.addRange(range);
    },
    /**
     * 执行指令
     * @param {*} command 
     * @param {*} val 接收部分功能所需要的参数，没有可以不穿
     */
    exec: function exec(command, val) {
        var _self = this; 
        if (_self.commandSet.indexOf(command) !== -1) {
            document.execCommand(command, false, val || null);
        } else { 
            var value = '<' + command + '>';  
            document.execCommand('formatBlock', false, value); 
        }
       

    },
    //设置标题
    settitle: function settitle(title, size, Weight, parent) {
        document.getElementById('editor').focus()
        var _self = this
        // if (_self.cache.editor.innerHTML.length == 0) {
        //     document.execCommand('insertHtml', false, '<p class="' + title + '" style="font-size:' + size + 'px;font-weight:' + Weight + '">&#8302</p>');
        //     return false
        // }

        var element = parent || _self.currentRange.startContainer
        var dom = element.parentElement

        if (dom.id == 'editor') {
            dom = element
        }
        else if (dom.tagName == 'OL' || dom.tagName == 'UL') {
            dom = element
        }
        if (dom.tagName == "div" || dom.tagName == 'LI') {
            dom.classList.remove(dom.classList[0])
            dom.classList.add(title)
            dom.style.fontSize = size + "px"
            dom.style.fontWeight = Weight;
            if (title == 'div') {
                dom.removeAttribute('class')
                dom.removeAttribute('style')
            }
        } else {
            this.settitle(title, size, Weight, dom.parentNode)
        }

    },
    /**
     * 设置列表
     * @param {*} val 
     * @param {*} parent 
     */
    OrderedList:function(val, parent) {
        var dom = parent || this.currentRange.startContainer.parentNode 
        if (dom.tagName == "LI") {
            if (val == dom.parentNode.localName) {
                //去掉列表
                var li = this.currentRange.startContainer.parentNode.parentNode.innerHTML 
                if (this.currentRange.startContainer.parentNode.parentNode.children.length === 1) {
                    var p = li.replace(/li/g, 'p').replace(/<\/\p>/g, '')
                    var text = this.currentRange.startContainer.parentNode.classList 
                    dom.parentNode.remove()

                    document.execCommand('insertHtml', null, p + '' + "&#8230</p>");
                } else { 
                    var p = dom.outerHTML
                    var list = dom.parentNode.outerHTML.replace(dom.outerHTML, '') 
                    dom.parentNode.remove()
                    document.execCommand('insertHtml', false, list + "<p class='title1'style='font-size:32px'>" + p + "</p>"); 
                }
            } else { 
                var li = this.currentRange.startContainer.parentNode.parentNode.innerHTML
                var list = "<" + val + ">" + li + "</" + val + ">"
                dom.parentNode.remove()
                this.insertHtml(list)
            }

        }
        if (dom.tagName == "P") {  
            var li = "<" + val + ">" + dom.outerHTML.replace(/p/g, 'li').replace(/lix/g, 'px') + "</" + val + ">"
            dom.remove()
            this.insertHtml(li)
        }

        if (dom.tagName != "P" && dom.tagName != "LI") { 
            if (dom.tagName == "DIV") {
                return false
            }
            this.OrderedList(val, dom.parentNode)
        }
        document.getElementById('editor').focus()

    },


    /**
     * 格式刷
     */
    repw: function repw() { 
        var _self = this
        var esult = document.getElementById('editor').innerHTML.replace(/style="[^\"]*?"/g, '')
        esult = esult.replace(/style='[^\']*?'/g, '')
        esult = esult.replace(/class="[^\"]*?"/g, '')
        esult = esult.replace(/class='[^\']*?'/g, '')
        document.getElementById('editor').innerHTML = ""
        _self.insertHtml(esult) 
    },

    /**
     * 获取当前的所有状态
     * @param {*} evt 
     */
    getEditItem: function getEditItem(evt) {
        //通过点击时，去获得一个当前位置的所有状态
        var _self = this;
        var _self$schemeCache2 = _self.schemeCache,
            STATE_SCHEME = _self$schemeCache2.STATE_SCHEME,
            CHANGE_SCHEME = _self$schemeCache2.CHANGE_SCHEME,
            IMAGE_SCHEME = _self$schemeCache2.IMAGE_SCHEME;

        if (evt.target && evt.target.tagName === 'A') {
            _self.cache.currentLink = evt.target;
            var name = evt.target.innerText;
            var href = evt.target.getAttribute('href');
            //  window.location.href = CHANGE_SCHEME + encodeURI(name + '@_@' + href);
        } else {
            if (evt.which == 8) {
                // AndroidInterface.staticWords(_self.staticWords());
            } 
            
            var items = [];
            if (document.queryCommandValue('fontSize')) {
                items.push('fontsize:' + document.queryCommandValue('fontSize'));
                _self.commandArray['fontSize'] = document.queryCommandValue('fontSize')
            }
            if (document.queryCommandValue('foreColor')) {
                items.push("foreColor:" + document.queryCommandValue('foreColor'));
                _self.commandArray['foreColor'] = document.queryCommandValue('foreColor')
            }
            _self.commandArray['list'] = ""
            _self.commandSet.forEach(function (item) {
                if (document.queryCommandState(item)) {
                    if (item == 'insertUnorderedList' || item == 'insertOrderedList') { 
                        _self.commandArray['list'] = item
                    }
                    if (item == 'justifyLeft' || item == 'justifyRight' || item == 'justifyCenter' || item == 'justifyFull') {
                        _self.commandArray['justify'] = item;
                    }
                    items.push(item + ':true');
                    _self.commandArray[item] = true
                } else {
                    if (item == "foreColor" || item == "fontSize") {

                    } else {
                        items.push(item + ':false');
                        _self.commandArray[item] = false
                    }
                }

            });
            if (document.queryCommandValue('formatBlock')) { 
                if (document.queryCommandValue('formatBlock') == 'h1' || document.queryCommandValue('formatBlock') == 'h2' || document.queryCommandValue('formatBlock') == 'h3' || document.queryCommandValue('formatBlock') == 'div') {
                    _self.commandArray['title'] = document.queryCommandValue('formatBlock');
                    return false
                }
                if (_self.currentRange.startContainer.parentNode) { 
                    if (_self.currentRange.startContainer.parentNode.classList.value) {
                        items.push('title:' + _self.currentRange.startContainer.parentNode.classList.value);
                        _self.commandArray['title'] = _self.currentRange.startContainer.parentNode.classList.value;
                    } else {
                        items.push('title:text');
                        _self.commandArray['title'] = 'text';
                    }

                }


            }

            if (_self.currentRange.endOffset == _self.currentRange.startOffset && _self.currentRange.startOffset > 0 && _self.currentRange.endContainer.data.length > 0) {
                var text = _self.currentRange.endContainer.data.substring(0, _self.currentRange.endOffset)
                items.push("search:" + text);
                _self.commandArray['search'] = text;
            } 
            //   window.location.href = STATE_SCHEME + encodeURI(items.join('++'));

        }
    }, 
    /**
     * 添加图片一
     */
    addimgsrc: function addimgsrc(imgsrc2) {
        //var imgsrc = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1542190063251&di=1d6c3d89a7e8b57450065ec17b15ab4c&imgtype=0&src=http%3A%2F%2Fpic.90sjimg.com%2Fback_pic%2Fqk%2Fback_origin_pic%2F00%2F04%2F43%2F570fcd6809ce6f032a8e96ca480b7def.jpg'

        //<p onclick="this.parentNode.parentNode.removeChild(this.parentNode);console.log(this.parentNode)" contenteditable="false" class="rem"><img style="width: 2rem;" src="https://img0.bevol.cn/UploadFile/find/0_3120c680-92ff-40d8-a01e-b09633f25f0d.png"></p>

        var imgsrc = imgsrc2
        var img = new Image()
        img.src = imgsrc
        img.onload = function () {
            if (this.width > window.innerWidth) {
                this.width = 100
                var htmls = '<div class="maximgbox" style="width:100%;overflow: hidden;text-algin:center"  contenteditable="false"><img src=' + imgsrc + ' style="width: 100%;"></div><p class="add"><br></p>'
            } else {
                var htmls = '<div class="imgbox" style="overflow: hidden;;text-align:center;text-algin:center"  contenteditable="false"><img src=' + imgsrc + ' style=" max-width: 100%;"></div><p class="add"><br></p>'
            }
            document.execCommand('insertHtml', false, htmls)
            this.init()
            this.getEditItem()
        }
    },


    /**
     * 获取文本信息
     * 错误的：onclick="Getinfo(@item.email);"
     * 正确的：onclick="Getinfo('@item.email');"
     */
    thishtml: function thishtml() {
        // var title = document.getElementsByClassName("title")[0].value
        var htmljson = document.getElementById("editor").innerHTML 
        // AndroidInterface.getTitleAndHtml(title, htmljson);
    },



    /**
     * 添加html代码
     * @param {*} html 
     */
    insertHtml: function insertHtml(html) {
        // html = "ertHtmlinsertHtmlinsertHtmlinsertHtml"
        document.execCommand('insertHtml', false, html);
    },


    /**
     * 设置背景颜色
     * @param {s} color 
     */
    setBackgroundColor: function setBackgroundColor(color) {
        var _self = this;
        document.body.style.backgroundColor = color;
    },



    /**
     * 添加横线(hr)的
     */
    insertLine: function insertLine() {
        var _self = this;
        var html = '<hr style="color:#F2F2F2"><p class="add"><br></p>';
        _self.insertHtml(html);
        _self.getEditItem({});
    },
    /**
     * 添加表格
     * @param {*} row 行 
     * @param {*} col 列
     */
    settable: function settable(row, col) {
        var word = prompt("请输入行*列用*号分隔开,默认3*3", "3*3"); 
        var xy = word.split("*")
        row = xy[0] - 0 || 3
        col = xy[1] - 0 || 3
        var _self = this
        var div = document.createElement("div"),
            table = document.createElement("table")
        table.style.width = '100%'
        table.style.borderSpacing = "0"
        table.style.border = "1px solid #999"
        table.style.borderTop = "none"
        table.style.borderRight = "none"
        for (var i = 0; i < row; i++) {
            var tr = document.createElement("tr");
            for (var j = 0; j < col; j++) {
                var td = document.createElement("td");
                td.style.width = "100px"
                td.style.border = "1px solid #999"
                td.style.borderBottom = "none"
                td.style.borderLeft = "none"
                tr.appendChild(td);
            }
            table.appendChild(tr)
        }
        div.appendChild(table)
        var tab_html = '<div class="row">' + div.innerHTML + '</div><div  class="row">&#8203;</div>'
        _self.insertHtml(tab_html);

    },
    /**
     * 插入列
     */
    appendCol: function appendCol() {
        var _self = this
        var dom = _self.currentRange 
        if (dom && dom.endContainer.parentNode && dom.startContainer.nodeName != "TBODY") {
            _self.parent(dom.endContainer.parentNode, 'col')
        }
        document.getElementById('editor').focus()
    },
    /**
     * 删除列
     */
    remCol: function remCol() {
        var _self = this
        document.getElementById('editor').focus()
        var dom = _self.currentRange

        if (dom && dom.endContainer.parentNode && dom.startContainer.nodeName != "TD") {
            _self.parentTr(dom.endContainer.parentNode, 'remcol', "TD")
        } else if (dom.startContainer.nodeName == "TD") {
            var index = dom.startContainer.cellIndex
            var table = dom.startContainer.parentNode.parentNode 
            for (let i = 0; i < table.querySelectorAll('tr').length; i++) {
                table.querySelectorAll('tr')[i].querySelectorAll('td')[index].remove()
            }
        }
    },
    /**
     * 删除行
     */
    remRow: function remRow() {
        var _self = this
        document.getElementById('editor').focus()
        var dom = _self.currentRange
        if (dom && dom.endContainer.parentNode && dom.startContainer.nodeName != "TR") {
            _self.parentTr(dom.endContainer.parentNode, 'remrow', "TR")
        }
    },
    /**
     * 删除表格
     */
    remTable:function() {
        var _self = this
        document.getElementById('editor').focus()
        var dom = _self.currentRange 
        if (dom && dom.endContainer.parentNode && dom.startContainer.nodeName != "TR") {
            _self.parentTr(dom.endContainer.parentNode, 'remtable', "TABLE")
        }
    },
    /**
     * 合并单元格
     * */
    RcolSpan:function() {
        var _self = this
        var dom = _self.currentRange
        if (dom && dom.startContainer.nodeName != "TD") {
            _self.parentTr(dom.endContainer.parentNode, 'Rcolspan', 'TD')
        } else if (dom.endContainer.nodeName == "TD") {
            var td_i = dom.endContainer.cellIndex,
                tr_i = dom.endContainer.parentNode.querySelectorAll('td') 
            if (tr_i.length > 1 && td_i < tr_i.length - 1) {
                tr_i[td_i].colSpan = tr_i[td_i].colSpan - 0 + tr_i[td_i + 1].colSpan - 0
                tr_i[td_i + 1].remove()
            }
        }
    },
    /**
     * 向左合并单元格
     */
    LcolSpan:function() {
        var _self = this
        var dom = _self.currentRange
        if (dom && dom.startContainer.nodeName != "TD") {
            _self.parentTr(dom.endContainer.parentNode, 'Lcolspan', 'TD')
        } else if (dom.endContainer.nodeName == "TD") {
            var td_i = dom.endContainer.cellIndex,
                tr_i = dom.endContainer.parentNode.querySelectorAll('td') 
            if (tr_i.length > 1 && td_i > 0) {
                tr_i[td_i].colSpan = tr_i[td_i].colSpan - 0 + tr_i[td_i - 1].colSpan - 0
                tr_i[td_i - 1].remove()
            }
        }
    },
    /**
     * 向上合并单元格
     */
    TrowSpan:function() {
        var _self = this
        var dom = _self.currentRange
        if (dom && dom.startContainer.nodeName != "TD") {
            _self.parentTr(dom.endContainer.parentNode, 'Tcolspan', 'TD')
        } else if (dom.endContainer.nodeName == "TD") {
            var td_i = dom.endContainer.cellIndex,
                tr_i = dom.endContainer.parentNode.parentNode.querySelectorAll('tr'),
                rowindex = dom.endContainer.parentNode.rowIndex 
            if (tr_i.length > 1 && rowindex > 0) {
                tr_i[td_i].rowSpan = tr_i[td_i].rowSpan - 0 + tr_i[td_i - 1].rowSpan - 0
                tr_i[td_i - 1].remove()
            }
        }
    },
    /**
    * 向下合并单元格
    */
    BrowSpan:function() {

    },
    /**
     * 首行缩进
     */
    appendNbsp: function appendNbsp() {
        var _self = this
        var dom = _self.currentRange
        if (dom && dom.endContainer.parentNode && dom.startContainer.parentNode.nodeName != "DIV") {
            _self.parentTr(dom.endContainer.parentNode, 'nbsp', 'DIV')
        } else if (dom.startContainer.parentNode.nodeName == "DIV") {
            dom.startContainer.parentNode.style.textIndent = '33px'
        }
        document.getElementById('editor').focus()
    },
    /**
     * 删除首行缩进
     */
    remNbsp: function remNbsp() {
        var _self = this
        document.getElementById('editor').focus()
        var dom = _self.currentRange
        if (dom && dom.endContainer.parentNode && dom.startContainer.parentNode.nodeName != "DIV") {
            _self.parentTr(dom.endContainer.parentNode, 'spke', 'DIV')
        } else if (dom.startContainer.parentNode.nodeName == "DIV") {
            dom.startContainer.parentNode.style.textIndent = ''
        } else {
            dom.startContainer.style.textIndent = ''
        }
    },
    /**
     * 插入行
     * @param {*} name 
     * @param {*} url 
     */
    appendRow: function appendRow() {
        var _self = this
        var dom = _self.currentRange 
        if (dom && dom.endContainer.parentNode && dom.startContainer.nodeName != "TBODY") {
            _self.parent(dom.endContainer.parentNode, 'row')
        }
        document.getElementById('editor').focus()
        //console.log(this.currentRange.endContainer.nextSibling.colSpan+=1)
    },

    /**
     *递归查找TBODY
     */
    parent: function parent(value, type) {
        var _self = this 
        if (value.parentNode && value.nodeName != "TBODY") {
            _self.parent(value.parentNode, type)
        } else if (value.nodeName == "DIV") {
            return false
        } else if (type == 'row') {
            //插入行
            var tr = value.firstChild
            var box = document.createElement("tr")
            for (let i = 0; i < tr.querySelectorAll('td').length; i++) {
                var td = document.createElement("td");
                td.style.width = "100px"
                td.style.border = "1px solid #999"
                td.style.borderBottom = "none"
                td.style.borderLeft = "none"
                box.appendChild(td);
            }
            value.innerHTML += "<tr>" + box.innerHTML + "</tr>"
        } else if (type == 'col') {
            //插入列
            for (let i = 0; i < value.querySelectorAll('tr').length; i++) {
                value.querySelectorAll('tr')[i].innerHTML = value.querySelectorAll('tr')[i].innerHTML + "<td style='width: 100px; border-top: 1px solid rgb(153, 153, 153); border-right: 1px solid rgb(153, 153, 153); border-bottom: none; border-left: none; border-image: initial;'></td>"
            }
        }
    },

    /**
     * 递归查找元素
     * 与上面的后期移植合并
     */
    parentTr: function parentTr(value, type, dom) {
        var _self = this 
        if (value.parentNode && value.nodeName != dom) {
            //重复调用自身进行查找
            _self.parentTr(value.parentNode, type, dom)
        } else if (type == "remrow" && value.nodeName == "TR") {
            //删除行
            value.remove()
        } else if (type == "remcol" && value.nodeName == "TD") {
            //删除列
            var index = value.cellIndex
            var table = value.parentNode.parentNode
            for (let i = 0; i < table.querySelectorAll('tr').length; i++) {
                table.querySelectorAll('tr')[i].querySelectorAll('td')[index].remove()
            }
        } else if (type == "remtable" && value.nodeName == "TABLE") {
            //删除表格
            value.parentNode.remove()
        } else if (type == "nbsp" && value.nodeName == "DIV") {
            //首行缩进
            value.parentNode.style.textIndent = '33px'
        } else if (type == "spke" && value.nodeName == "DIV") {
            //取消首行缩进
            value.parentNode.style.textIndent = ''
        } else if (type == "Rcolspan" && value.nodeName == "TD") {
            //合并单元格
            var td_i = value.cellIndex,
                tr_i = value.parentNode.querySelectorAll('td')
            if (tr_i.length > 1 && td_i < tr_i.length - 1) { 
                tr_i[td_i].innerHTML = tr_i[td_i].innerHTML + tr_i[td_i + 1].innerHTML
                tr_i[td_i].colSpan = tr_i[td_i].colSpan - 0 + tr_i[td_i + 1].colSpan - 0
                tr_i[td_i + 1].remove()
            }
        } else if (type == "Lcolspan" && value.nodeName == "TD") {
            //合并单元格
            var td_i = value.cellIndex,
                tr_i = value.parentNode.querySelectorAll('td')
            if (tr_i.length > 1 && td_i <= tr_i.length - 1) {
                tr_i[td_i].innerHTML = tr_i[td_i - 1].innerHTML + tr_i[td_i].innerHTML
                tr_i[td_i].colSpan = tr_i[td_i].colSpan - 0 + tr_i[td_i - 1].colSpan - 0
                tr_i[td_i - 1].remove()
            }
        }
    },
    /**
     * 添加超链接
     * @param {标题} name 
     * @param {链接} url 
     */
    insertLink: function insertLink(name, url) {
        var _self = this;
        var html = '<a href="' + url + '" class="editor-link">' + name + '</a>';
        _self.insertHtml(html);
    },

    /**
     * 添加图片二
     * @param {*} url 
     * @param {*} id 
     * @param {*} width  
     */
    insertImage: function insertImage(url, id, width) {
        document.getElementById('editor').focus()
        var _self = this;
        var newWidth = 0
        var screenWidth = _self.setting.screenWidth;

        if (width > screenWidth) {
            newWidth = '100%';
        } else {
            newWidth = width + 'px';
        }
        var image = '<div class="block" style="text-align: center">\n\t\t\t\t<div class="img-block">\n\t\t\t\t<img class="images" data-id="' + id + '" style="width: ' + newWidth + ';height: 100%;" src="' + url + '"/>\n\t\t\t\t<div class="cover" style="width: ' + newWidth + ';height: 100%"></div>\n\t\t\t\t</div><div>&#8302</div>';
        _self.insertHtml(image);
        var img = document.querySelector('img[data-id="' + id + '"]');
        var imgBlock = img.parentNode;
        imgBlock.parentNode.contentEditable = false;
        imgBlock.addEventListener('click', function (e) {
            e.stopPropagation(); 
            var current = e.currentTarget;
            var img = current.querySelector('.images');
            var id = img.getAttribute('data-id');
            //   window.location.href = _self.schemeCache.IMAGE_SCHEME + encodeURI(id);
        }, false);
        _self.imageCache.put(id, imgBlock.parentNode);
    },



    changeProcess: function changeProcess(id, process) {
        var _self = this;
        var block = _self.imageCache.get(id);
        var fill = block.querySelector('.fill');
        fill.style.width = process + '%';
        if (process == 100) {
            var cover = block.querySelector('.cover');
            var process = block.querySelector('.process');
            var imgBlock = block.querySelector('.img-block');
            imgBlock.removeChild(cover);
            imgBlock.removeChild(process);
        }
    },

    /**
     * 删除图片
     * @param {*} id 
     */
    removeImage: function removeImage(id) {
        var _self = this;
        var block = _self.imageCache.get(id);
        block.parentNode.removeChild(block);
        _self.imageCache.remove(id);
    },



    uploadFailure: function uploadFailure(id) {
        var _self = this;
        var block = _self.imageCache.get(id);
        var del = block.querySelector('.delete');
        del.style.display = 'block';
    },
    uploadReload: function uploadReload(id) {
        var _self = this;
        var block = _self.imageCache.get(id);
        var del = block.querySelector('.delete');
        del.style.display = 'none';
    },


};

// RE.init();

/**初始化获取标题焦点*/
// window.onload = function () {
//     document.getElementsByClassName('title')[0]?.focus();
// };
export default RE 



// WEBPACK FOOTER //
// ./src/pages/editor/richeditor.js